import {configureStore} from '@reduxjs/toolkit';
import authenticationsSlice from './reducers/authentications/authenticationsSlice';
import placesSlice from './reducers/places/placesSlice';
import sourcesSlice from './reducers/infrastructure/sourcesSlice';
import readingsSlice from './reducers/readings/readingsSlice';


const store = configureStore({
  reducer:{
      authentications:authenticationsSlice,
      places: placesSlice,
      sources: sourcesSlice,
      readings: readingsSlice
  }
});


export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']

export default store;
